import React, { Fragment, useState } from 'react';
import { Button, Box } from '@indeed/ifl-components';
import { Chat, Home, FileDoc, Bookmark, MyPage, Hamburger } from '@indeed/ifl-icons';
import SideMenu from './_SideMenu';
import { style } from './GlobalNavBarview.jss';
import Logo from 'Img/indeed-logo.svg';
import './GlobalNavBarView.scss';
export default function GlobalNavBarView({ surveyUrl, appHomeUrl, myPageUrl, isLoggedIn, loginUrl, profileUrl, selectedButton, headerContent, customRightButton }) {
    const [showSideMenu, setShowSideMenu] = useState(false);
    // Show menu button by default if the `customRightButton` parameter is not specified
    // Show placeholder if customRightButton is null, false, etc.
    const rightButton = typeof customRightButton === 'undefined' ? (React.createElement(Button, { size: "sm", variant: "primary", className: "GlobalNavBarView-sidemenuButton", onClick: () => setShowSideMenu(true), "aria-label": "\u30E1\u30CB\u30E5\u30FC", iconOnly: true },
        React.createElement(Hamburger, { "aria-hidden": true }))) : (customRightButton || React.createElement("div", { className: "GlobalNavBarView-actionPlaceHolder" }));
    return (React.createElement(Box, { className: "GlobalNavBarView", sx: style.main },
        React.createElement("div", { className: "GlobalNavBarView-content" },
            React.createElement("div", { className: "GlobalNavBarView-logo" },
                React.createElement("img", { src: Logo, alt: "\u30A4\u30F3\u30C7\u30A3\u30FC\u30C9" })),
            headerContent,
            React.createElement("div", { className: "GlobalNavBarView-navItems" },
                React.createElement(Box, { as: "span", sx: style.navItemSeparator }),
                React.createElement(Box, { as: "a", className: "GlobalNavBarView-navItem", href: "/rirekisho", sx: {
                        ...style.navItem,
                        ...(selectedButton === 'howto' ? style.activeNavItem : {})
                    } },
                    React.createElement("span", { className: "GlobalNavBarView-navItemIcon" },
                        React.createElement(Bookmark, null)),
                    "\u5C65\u6B74\u66F8\u306E\u66F8\u304D\u65B9"),
                React.createElement(Box, { as: "span", sx: style.navItemSeparator }),
                React.createElement(Box, { className: "GlobalNavBarView-navItem", href: surveyUrl, target: "_blank", sx: style.navItem, as: "a" },
                    React.createElement("span", { className: "GlobalNavBarView-navItemIcon" },
                        React.createElement(Chat, null)),
                    "\u30D5\u30A3\u30FC\u30C9\u30D0\u30C3\u30AF"),
                React.createElement(Box, { as: "span", sx: style.navItemSeparator }),
                React.createElement(Box, { className: "GlobalNavBarView-navItem", href: appHomeUrl, as: "a", sx: {
                        ...style.navItem,
                        ...(selectedButton === 'home' ? style.activeNavItem : {})
                    } },
                    React.createElement("span", { className: "GlobalNavBarView-navItemIcon" },
                        React.createElement(Home, null)),
                    "\u30A2\u30D7\u30EA\u30DB\u30FC\u30E0"),
                React.createElement(Box, { as: "span", sx: style.navItemSeparator }),
                isLoggedIn && profileUrl && (React.createElement(Fragment, null,
                    React.createElement(Box, { className: "GlobalNavBarView-navItem", href: profileUrl, sx: {
                            ...style.navItem,
                            ...(selectedButton === 'profile' ? style.activeNavItem : {})
                        }, as: "a" },
                        React.createElement("span", { className: "GlobalNavBarView-navItemIcon" },
                            React.createElement(FileDoc, null)),
                        "\u30D7\u30ED\u30D5\u30A3\u30FC\u30EB"),
                    React.createElement(Box, { as: "span", sx: style.navItemSeparator }))),
                React.createElement(Box, { as: "a", className: "GlobalNavBarView-navItem", href: myPageUrl, sx: {
                        ...style.navItem,
                        ...(selectedButton === 'mypage' ? style.activeNavItem : {})
                    } },
                    React.createElement("span", { className: "GlobalNavBarView-navItemIcon" },
                        React.createElement(MyPage, null)),
                    "\u30DE\u30A4\u30DA\u30FC\u30B8"),
                React.createElement(Box, { as: "span", sx: style.navItemSeparator })),
            !isLoggedIn && (React.createElement("div", { className: "GlobalNavBarView-accountItems" },
                React.createElement(Button, { as: "a", href: loginUrl, variant: "primary", size: "sm" }, "\u30ED\u30B0\u30A4\u30F3")))),
        React.createElement("div", { className: "GlobalNavBarView-mobileContent" },
            headerContent ? (headerContent) : (React.createElement("div", { className: "GlobalNavBarView-logo" },
                React.createElement("img", { src: Logo, alt: "\u30A4\u30F3\u30C7\u30A3\u30FC\u30C9" }))),
            rightButton),
        React.createElement(SideMenu, { show: showSideMenu, onDismiss: () => setShowSideMenu(false), myPageUrl: myPageUrl, surveyUrl: surveyUrl, appHomeUrl: appHomeUrl, profileUrl: isLoggedIn ? profileUrl : undefined, selectedButton: selectedButton })));
}
